export { Subtitle1, subtitle1ClassNames } from './components/presets/Subtitle1/index';
